import React from "react";
import EventsList from "../../../../components/sections/front/wishlist/EventsList";
import OrganizationList from "../../../../components/sections/front/wishlist/OrganizationList";
import Tabs from "../../../elements/Tabs";
import { t } from "i18next";

const HubInterests = ({ selectedProfile = {} }) => {
  const tabItems = [
    {
      label: t("Events"),
      icon: "fa-regular fa-grid",
      content: (
        <EventsList
          listClass={"grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4"}
        />
      ),
    },
    {
      label: t("Organizations"),
      icon: "fa-regular fa-chart-line",
      content: (
        <OrganizationList
          listClass={"grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4"}
        />
      ),
    },
  ];

  return (
    <>
      <Tabs
        items={tabItems}
        contentClass={"w-full"}
        tabsClass="gap-3 p-5 flex items-center gap-4 rounded-lg border-t border-slate-100"
        tabClass={
          "h-11 rounded-full bg-transparent border border-gray-200 flex items-center justify-center !text-deep-purple p-5 text-base capitalize font-normal"
        }
        activeTabClass={"bg-primary border border-primary !text-white"}
      />
    </>
  );
};

export default HubInterests;
